import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import useMakeFilter from '@src/deserialize/hook/useMakeFilter'
import { BountyFilterData } from '@src/types/bounty'
import * as R from 'ramda'

const useFetchBountyFilterJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  const { makeSlideFilter } = useMakeFilter()

  return useReactQueryFetchJson<BountyFilterData>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.BOUNTY_APOSTLE_FILTERS,
    deserialize: (response: any) => {
      return {
        others: R.isNotNil(response) ? response.others.map(makeSlideFilter) : []
      }
    }
  })
}

export default useFetchBountyFilterJson
